<template>
    <section class="perks-widget__offers">
        <h2>Offers</h2>
        <div
            v-if="offers && offers.length"
            class="offer-list"
        >
            <div
                v-for="offerGroup in offers"
                :key="offerGroup.vendor.vend_id"
                class="offer-list__item"
            >
                <div class="perks-widget__box">
                    <div v-if="offerGroup.vendor.logo">
                        <img
                            :src="offerGroup.vendor.logo.url"
                            class="img--natural"
                        >
                    </div>
                    <h3>{{ offerGroup.vendor.v_name }}</h3>
                    <ul>
                        <li
                            v-for="offer in offerGroup.offers"
                            :key="offer.id"
                        >
                            <a
                                :href="'https://demo.abenity.com/discounts/offer/' + offer.provider_id + ':' + offer.provider_offer_id"
                                rel="noopener noreferrer"
                                target="_blank"
                                v-html="offer.offer_title"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'offers'
        ])
    }
};
</script>
